import emailMisspelled, { top100 as domains } from 'email-misspelled';

export function emailSuggestion(email) {
  const [username] = email.split('@');

  const emailDomainChecker = emailMisspelled({ domains });
  const checkedEmailDomain = emailDomainChecker(email);
  const suggestedEmailDomain = checkedEmailDomain.length ? checkedEmailDomain[0].suggest : '';
  const suggestedEmail = suggestedEmailDomain ? `${username}@${suggestedEmailDomain}` : '';

  return suggestedEmail;
}
